import { axios } from '@/utils/axios'
// import _ from 'lodash'
// import moment from 'moment'

// 请求支付
export async function payOrder (params) {
  try {
    return await axios.post('/api/payment/payOrder', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 新版 - 请求支付（组合支付）
 * @param {Object} payExtend[mergeType] 新增参数拓展组合支付
 * @returns {{ url }}
 */
export async function payOrderNew (params) {
  try {
    return await axios.post('/api/uniPayment/V3/payOrder', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取微信支付二维码
export async function showQRCode (params) {
  try {
    return await axios.post('/api/payment/showQRCode', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取支付状态
export async function payState (params) {
  try {
    return await axios.post('/api/payment/payState', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 新版 - 获取支付状态
export async function payStateNew (params) {
  try {
    // return await axios.post('/api/uniPayment/payState', params)
    return await axios.post('/api/uniPayment/V3/payState', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 支付差错
export async function misPay (params) {
  try {
    return await axios.post('/api/payOrder/misPay', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 新版 - 支付差错
export async function misPayNew (params) {
  try {
    return await axios.post('/api/uniPayment/misPay', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 票号同步接口
export async function syncTicketNo (params) {
  try {
    return await axios.post('/api/payOrder/synTicketNo', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取虚拟支付信息
export async function virtualPayInfo (params) {
  try {
    return await axios.post('/api/payment/showVirtualpay', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取花呗支付信息
export async function getHbInfos (params) {
  try {
    return await axios.post('/api/uniPayment/V3/getHbInfos', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询海航通余额
export async function queryBalance (params) {
  try {
    return await axios({
      url: '/api/uniPayment/V3/queryBalance',
      method: 'post',
      data: params,
      timeout: 5000
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
